import { render, staticRenderFns } from "./aside.component.vue?vue&type=template&id=4b7f4049"
import script from "./aside.component.vue?vue&type=script&lang=js"
export * from "./aside.component.vue?vue&type=script&lang=js"
import style0 from "./aside.component.vue?vue&type=style&index=0&id=4b7f4049&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports